import colors from 'shared/colors';

const mcColorSet = [
  colors.green.lighten2,
  colors.red.lighten2,
  colors.orange.lighten2,
  colors.blue.lighten2,
  colors.yellow.lighten2,
  colors.green.base,
  colors.orange.base,
  colors.blue.base,
  colors.red.base,
  colors.yellow.base,
  colors.orange.lighten1,
  colors.blue.lighten1,
  colors.green.lighten1,
  colors.red.lighten1,
  colors.yellow.lighten1,
];

export default (t) => ({
  chart: {
    style: {
      fontFamily: '\'-apple-system\', \'BlinkMacSystemFont\', \'Segoe UI\', \'PingFang SC\', \'Hiragino Sans GB\', '
        + '\'Microsoft YaHei\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
    },
  },
  colors: mcColorSet,
  credits: { enabled: false },
  exporting: { enabled: false },
  legend: { enabled: false },
  title: { text: '' },
  // this only affects the initial animation
  plotOptions: { series: { animation: false } },
  lang: {
    decimalPoint: t('highcharts.decimalPoint'),
    thousandsSep: t('highcharts.thousandsSep'),
    months: t('highcharts.months'),
    shortMonths: t('highcharts.shortMonths'),
    weekdays: t('highcharts.weekdays'),
  },
});
